export enum LogoCloudVariations {
  WithTitle = 'logoCloudWithTitle',
  multipleCentered = 'logoCloudMultipleCentered',
}
